<div class="stats-tile" [matTooltip]="description">
    <div class="stats-icon">
        <img class="tile-icon" alt="tile-icon" [src]="icon"
            [class.tile-icon-for-operators]="label === 'overloaded' || label === 'active'" />
    </div>
    <div class="stats-detail">
        <div class="stats-count">{{ value }}</div>
        <div class="stats-label">{{ label }}</div>
    </div>
</div>